import React from 'react';
import { MuiFab } from '@ace/ace-ui-web';

interface ScrollToTopButtonProps {
  isShow: boolean;
  onClick: () => void;
  ariaLabel?: string;
}

/**
 * Floating scroll-to-top button component
 * Appears in bottom-right corner when show prop is true
 *
 * @param show - Whether to display the button
 * @param onClick - Function to call when button is clicked
 * @param ariaLabel - Accessibility label for the button
 *
 * @example
 * <ScrollToTopButton show={showButton} onClick={scrollToTop} />
 */
const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({
  isShow,
  onClick,
  ariaLabel = 'Scroll to top of page',
}) => {
  if (!isShow) return null;
  return (
    <MuiFab
      onClick={onClick}
      aria-label={ariaLabel}
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
      }}
    />
  );
};

export default ScrollToTopButton;
